var _path, _path2, _path3, _path4, _path5, _path6, _rect, _polygon, _rect2, _polygon2, _rect3, _rect4, _polygon3, _rect5, _polygon4, _rect6, _rect7, _polygon5, _rect8, _polygon6, _rect9, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ProductsPile50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M22.941,42H7.059C6.476,42,6,41.55,6,41V28h18v13C24,41.55,23.524,42,22.941,42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa2e",
    d: "M25,28H5v-3c0-0.55,0.474-1,1.053-1h17.895C24.526,24,25,24.45,25,25V28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M40.941,42H25.059C24.476,42,24,41.55,24,41V28h18v13C42,41.55,41.524,42,40.941,42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa2e",
    d: "M43,28H23v-3c0-0.55,0.474-1,1.053-1h17.895C42.526,24,43,24.45,43,25V28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M31.941,24H16.059C15.476,24,15,23.55,15,23V10h18v13C33,23.55,32.524,24,31.941,24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa2e",
    d: "M34,10H14V7c0-0.55,0.474-1,1.053-1h17.895C33.526,6,34,6.45,34,7V10z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 9,
    y: 36,
    fill: "#754600"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#754600",
    points: "11,36 8,36 9.507,34.002"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2.049,
    x: 13,
    y: 35.951,
    fill: "#754600"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#754600",
    points: "15,36 12,36 13.498,34"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 8,
    y: 39,
    fill: "#754600"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 27,
    y: 36,
    fill: "#754600"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#754600",
    points: "29,36 26,36 27.507,34.002"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2.049,
    x: 31,
    y: 35.951,
    fill: "#754600"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#754600",
    points: "33,36 30,36 31.498,34"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 26,
    y: 39,
    fill: "#754600"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 18,
    y: 18,
    fill: "#754600"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#754600",
    points: "20,18 17,18 18.507,16.002"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2.049,
    x: 22,
    y: 17.951,
    fill: "#754600"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#754600",
    points: "24,18 21,18 22.498,16"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 17,
    y: 21,
    fill: "#754600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c77600",
    d: "M32.035,24h-16.05C15.441,24,15,23.559,15,23.015V23h18v0.035C33,23.568,32.568,24,32.035,24z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#c77600",
    d: "M24,24v17c0,0.552-0.448,1-1,1h0V24H24z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#c77600",
    d: "M24,25c0-0.552,0.448-1,1-1h-1V25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#c77600",
    d: "M23,25c0-0.552-0.448-1-1-1h1V25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ProductsPile50);
export default __webpack_public_path__ + "static/media/icons8-products-pile-50.4db825e43ec6671962af562ddb29406d.svg";
export { ForwardRef as ReactComponent };